import moment from 'moment'

export default {
    formattedDate(date: string) {
        if (!date) {
            return ''
        }
        const parsed = moment(date);
        return parsed.format('DD.MM.YYYY - HH:mm')
    }
}
